<template>
  <el-dialog
    title="使用范围"
    top="5vh"
    width="60%"
    :visible="ChooseDialogVisible"
    @close="openPup(false)"
  >
    <p
      style="
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #290202;
        margin-bottom: 20px;
      "
    >
      <i class="warn-img el-icon-warning"></i>
<!--      选中的成员，在发起合同时需先进行审批，审批通过后合同才会成功发起-->
      选中的成员，在发起合同时选择此流程，无需进行任何审批即可发起，请谨慎使用！
    </p>

    <el-form
      size="small"
      :inline="true"
      :model="memberForm"
      class="demo-form-inline"
      style="margin: -10px 0 10px 0; text-align: right"
    >
      <el-form-item>
        <el-input
          style="width: 220px"
          v-model="memberForm.targetId"
          placeholder="邮箱/手机号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          style="width: 220px"
          v-model="memberForm.userName"
          placeholder="签署方名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="memberForm.corpGroupId"
          placeholder="请选择部门"
          style="width: 150px"
        >
          <el-option label="全部" :value="-1" />
          <el-option
            v-for="(item, index) in treeGroups"
            :key="index"
            :label="item.groupName"
            :value="item.corpGroupId"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-right: 0px">
        <el-button @click="getCmSealUsers()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.corpUserId"
      :data="unSealUsers"
      style="border: 1px solid #eeeeee; border-bottom: 0; margin-top: -15px"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '600',
      }"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        label="邮箱/手机号"
        show-overflow-tooltip
        prop="targetId"
      ></el-table-column>
      <el-table-column
        label="名称"
        show-overflow-tooltip
        prop="userName"
      ></el-table-column>
      <el-table-column
        label="部门"
        prop="groupNames"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="ChooseMember"
        >确认</el-button
      >
    </span>
    <el-row class="pageation" v-if="pageTotal > 0">
      <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
        <el-pagination
          @size-change="approSizeChange"
          @current-change="approCurrentChange"
          :current-page="itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, total"
          :total="pageTotal"
        />
        <el-go
          :page-size="pageSize"
          :total="pageTotal"
          @current-change="approCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import ElGo from "../../../components/go/Go";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";

export default {
  components: { ElGo },
  props: { ChooseDialogVisible: Boolean, selectUsers: { type: Array, default: () => [] }, flowId: { type: Number, default: null } },
  data () {
    // 这里存放数据
    return {
      itemPage: 1,
      pageTotal: 0,
      pageSize: 10,
      treeGroups: [],
      unSealUsers: [],
      selectionRow: [],
      selectionRowEdit: [],
      memberForm: {
        targetId: "",
        userName: "",
        corpGroupId: -1,
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
  },
  // 方法集合
  methods: {
    toggleSelection (rows) {
      if (rows) {
        this.$nextTick(() => {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        })
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 确认
    ChooseMember () {
      // 清空
      this.memberForm.targetId = "";
      this.memberForm.userName = "";
      this.memberForm.corpGroupId = -1;
      if (this.selectionRow.length === 0)
        return this.$message.error("请选择使用人");
      this.$message.success('选择完成')
      this.$emit('handleSelectUser', this.selectionRow)
      this.openPup(false)
    },
    getCmSealUsers (auth) {
      const { targetId, userName, corpGroupId } = this.memberForm;
      const param = { auth: 0, targetId, userName, corpGroupId: corpGroupId === -1 ? '' : corpGroupId, itemPage: this.itemPage, pageSize: this.pageSize }
      if (this.flowId || this.flowId === 0) param.flowId = this.flowId
      // ApiCorpMethods.OrganizationController.listCorpUsers(param)
      ApiCorpMethods.FlowController.findflowByUserPaged(param)
        .then(res => {
          if (res.code === "0") {
            this.unSealUsers = res.data;
            this.pageTotal = res.total;
            if (this.$route.query.flowId) {
              const selectFlow = []
              this.selectionRowEdit.forEach(select => {
                this.unSealUsers.forEach(item => {
                  if (item.corpUserId === select.corpUserId) selectFlow.push(item)
                })
              })
              this.toggleSelection(selectFlow)
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    initTreeGroupApproval () {
      let params = {};
      params.permId = 4;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code === 0) {
            this.convertFormateTree(res.data);
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    convertFormateTree (tree) {
      tree.forEach(i => {
        this.treeGroups.push({
          corpGroupId: i.corpGroupId,
          groupName: i.groupName
        });
        if (i.childCorpGroups && i.childCorpGroups.length !== 0)
          this.convertFormateTree(i.childCorpGroups);
      });
    },
    handleSelectionChange (val) {
      this.selectionRow = val;
    },
    initMemberForm () {
      this.openPup(true)
      this.memberForm = {
        targetId: "",
        userName: "",
        corpGroupId: -1
      };
      this.selectionRowEdit = this.selectUsers
      this.getCmSealUsers();
    },
    openPup (visi) {
      this.$emit("update:ChooseDialogVisible", visi)
    },
    // 重置
    reset () {
      this.memberForm = {
        targetId: "",
        userName: "",
        corpGroupId: -1
      };
      this.itemPage = 1
      this.pageTotal = 0
      this.pageSize = 10
      this.getCmSealUsers();
    },
    approCurrentChange (val) {
      this.itemPage = val;
      this.getCmSealUsers();
    },
    approSizeChange (val) {
      this.pageSize = val;
      this.getCmSealUsers();
    },

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { this.initTreeGroupApproval(); },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
}
</script>
<style lang='less' scoped>
</style>



// WEBPACK FOOTER //
// pages/console/components/selectePup.vue